module.exports = __webpack_public_path__ + "static/media/hand-paper.8bfa12f5.svg";